// SCRIPT GUIDE DES TAILLES
// 2021 Février - UpWork Chander Shekhar
/* ============================================================================
   mm-modal-taille.js — mémorisation du téléphone choisi (guide des tailles)
   ----------------------------------------------------------------------------
   Chargé par sections/MM-Modal-Tailles.liquid (script defer en fin de section).
   Quand le visiteur valide un téléphone dans la pop-up guide des tailles
   (marque + modèle), le choix est persisté en localStorage (Phone_brand,
   Phone_model, Phone_size, Phone_brand_model). Au chargement des pages
   suivantes, getPhoneModel() rejoue ce choix : remplace le bouton
   "Guide des tailles" par "Marque - Modèle" + croix d'oubli, et re-simule la
   sélection dans la modale pour resynchroniser la variante du produit.
   Fonctions de la modale appelées ici mais définies dans
   sections/MM-Modal-Tailles.liquid : mmOpenSizeModal (onclick injecté).
   ========================================================================== */

// NB : constante jamais utilisée ensuite (variable morte) ; le script étant
// defer, le select existe déjà au moment de cette lecture.
const brandPhoneSelect = document.getElementById('mm-marque-select');

// Oublie le téléphone mémorisé (croix sur le bouton compatible) : purge le
// localStorage puis recharge la page pour restaurer le bouton d'origine.
// Appelée via l'attribut onclick du SVG injecté par mmUpdateCTASize /
// getPhoneModel ci-dessous.
function forgetUserChoicePhone() {
  // Set item
  localStorage.removeItem("Phone_brand");
  localStorage.removeItem("Phone_model");
  localStorage.removeItem("Phone_brand_model");
  localStorage.removeItem("Phone_size");

  location.reload();
}

// Enregistre le choix en localStorage puis remplace (outerHTML) les boutons
// "Guide des tailles" du formulaire produit par le libellé "Marque - Modèle"
// avec croix d'oubli. Appelée par la validation de la pop-up dans
// sections/MM-Modal-Tailles.liquid (bouton mmModalSizeSubmit).
function mmUpdateCTASize(brand, model, size) {
  // Set item
  localStorage.setItem("Phone_brand", `${brand}`);
  localStorage.setItem("Phone_model", `${model}`);
  localStorage.setItem("Phone_size", `${size}`);
  localStorage.setItem("Phone_brand_model", `${brand} - ${model}`);

  var buttons = document.querySelectorAll('#product-form .mm-size-modal-button');

  if (buttons) {
    buttons.forEach(function (button) {
      const isDesktop = button.classList.contains('mm-desktop');
      const desktopClass = isDesktop ? ' mm-desktop' : '';

      button.outerHTML = `
        <span class="mm-size-modal-button mm-moto-cta-compatible${desktopClass}">
          <p onclick="mmOpenSizeModal()">${brand} - ${model}</p>
          <svg onclick="forgetUserChoicePhone()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </span>
      `;
    });
  }
}

// Rejoue le choix mémorisé au chargement de la page (DOMContentLoaded plus
// bas) : pré-remplit la recherche, remplace les boutons guide des tailles,
// puis re-simule la sélection dans la modale (change sur #mm-marque-select,
// click sur #mmModalSizeSubmit) pour que la variante produit suive.
// NB : #mm-model-select reçoit Phone_size (et non Phone_model) — voulu, le
// select des modèles porte la taille en value ; piège à la relecture.
function getPhoneModel() {
  if(localStorage.getItem("Phone_brand_model")){
    var phone_model = localStorage.getItem("Phone_brand_model");

    // Pre-fill the search input with saved model
    var searchInput = document.getElementById('mm-size-search-input');
    if (searchInput) searchInput.value = phone_model;

    var buttons = document.querySelectorAll('.mm-size-modal-button');

    if (buttons) {
      buttons.forEach(function (button) {
        const isDesktop = button.classList.contains('mm-desktop');
        const desktopClass = isDesktop ? ' mm-desktop' : '';

        button.outerHTML = `
          <span class="mm-size-modal-button mm-moto-cta-compatible${desktopClass}">
            <p onclick="mmOpenSizeModal()">${phone_model}</p>
            <svg onclick="forgetUserChoicePhone()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </span>
        `;
      });
    }

    // Populate the modal via hidden selects
    document.getElementById('mm-marque-select').value = localStorage.getItem("Phone_brand");
    var event = new Event('change');
    document.getElementById('mm-marque-select').dispatchEvent(event);

    document.getElementById('mm-size-model').style.display = 'flex';
    document.getElementById('mm-model-select').value = localStorage.getItem("Phone_size");
    var event = new Event('click');
    document.getElementById('mmModalSizeSubmit').dispatchEvent(event);
  }
}

// Setup button onload
// 03/08/2026 : le rejeu attend que la base téléphones (désormais téléchargée
// en asynchrone par la section, cf. window.mmBaseTaillesPrete) soit chargée —
// sinon les selects sont vides au moment de rejouer la sélection mémorisée.
document.addEventListener("DOMContentLoaded", (event) => {
  if (window.mmBaseTaillesPrete) {
    window.mmBaseTaillesPrete.then(getPhoneModel);
  } else {
    getPhoneModel();
  }
});
